(function () {
  if (!navigator.modelContext || typeof navigator.modelContext.provideContext !== "function") {
    return;
  }

  function localPath(path) {
    var routes = window.Shopify && window.Shopify.routes;
    var root = (routes && routes.root) || document.documentElement.dataset.rootUrl || '/';
    return root.replace(/\/$/, '') + path;
  }

  function fetchJson(url, options) {
    url = localPath(url);
    return fetch(url, Object.assign({ credentials: "same-origin", headers: { Accept: "application/json" } }, options || {})).then(function (res) {
      if (!res.ok) {
        throw new Error("Request failed: " + res.status + " " + res.statusText);
      }
      return res.json();
    });
  }

  var tools = [
    {
      name: "search_products",
      description: "Search Conde Professional hair extensions by query (color, length, texture, or method).",
      inputSchema: {
        type: "object",
        properties: {
          query: { type: "string", description: "Search terms (e.g. 'merlot fantasy 20 inch')" },
          limit: { type: "integer", minimum: 1, maximum: 20, default: 10 }
        },
        required: ["query"]
      },
      execute: function (input) {
        var limit = input.limit || 10;
        var url = "/search/suggest.json?q=" + encodeURIComponent(input.query) + "&resources[type]=product&resources[limit]=" + limit;
        return fetchJson(url).then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          return { products: products.map(function (p) {
            return { title: p.title, handle: p.handle, url: p.url, price: p.price, vendor: p.vendor, product_type: p.product_type };
          }) };
        });
      }
    },
    {
      name: "get_product",
      description: "Get full details and available variants for a Conde product by its URL handle.",
      inputSchema: {
        type: "object",
        properties: {
          handle: { type: "string", description: "Product handle from its URL (e.g. 'tape-in-merlot-fantasy')" }
        },
        required: ["handle"]
      },
      execute: function (input) {
        return fetchJson("/products/" + encodeURIComponent(input.handle) + ".js").then(function (p) {
          return {
            title: p.title,
            handle: p.handle,
            description: p.description,
            vendor: p.vendor,
            type: p.type,
            tags: p.tags,
            price: p.price,
            price_min: p.price_min,
            price_max: p.price_max,
            available: p.available,
            variants: (p.variants || []).map(function (v) {
              return { id: v.id, title: v.title, sku: v.sku, price: v.price, available: v.available, options: v.options };
            })
          };
        });
      }
    },
    {
      name: "add_to_cart",
      description: "Add a Conde product variant to the current cart. Requires a variant id from get_product.",
      inputSchema: {
        type: "object",
        properties: {
          variant_id: { type: "integer", description: "Numeric variant id (not GID)" },
          quantity: { type: "integer", minimum: 1, default: 1 }
        },
        required: ["variant_id"]
      },
      execute: function (input) {
        var body = { id: input.variant_id, quantity: input.quantity || 1 };
        return fetchJson("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(body)
        });
      }
    },
    {
      name: "get_cart",
      description: "Return the current cart contents, including items, totals, and currency.",
      inputSchema: { type: "object", properties: {} },
      execute: function () {
        return fetchJson("/cart.js").then(function (c) {
          return {
            item_count: c.item_count,
            total_price: c.total_price,
            currency: c.currency,
            items: (c.items || []).map(function (i) {
              return { title: i.product_title, variant_title: i.variant_title, quantity: i.quantity, price: i.price, line_price: i.line_price, url: i.url };
            })
          };
        });
      }
    }
  ];

  try {
    navigator.modelContext.provideContext({ tools: tools });
  } catch (e) {
    if (window.console && console.warn) console.warn("WebMCP provideContext failed:", e);
  }
})();
